<template>
  <div>
    <div class="subject-preference">
      <div class="preference-title-row">
        <!-- TITLE -->
        <div class="preference-title">Subjects</div>
        <!-- PLUS ICON -->
        <div class="avatar avatar_sm_md pointer" @click="toggleSubjectModal">
          <span
            class="flex-center icon-plus font-17 color_text font-weight-600"
          ></span>
        </div>
      </div>

      <!-- SUBJECT CARD COMPONENTS -->
      <div
        class="loader d-flex justify-content-center align-items-center my-4"
        v-if="subject_list.length < 1"
      >
        <div class="avatar avatar_sm_md">
          <span
            class="icon-dotted-spinner flex-center font-22 border_grey-dark animate mr-3"
          ></span>
        </div>
        <div class="text color_grey_dark font-14">Loading Subjects ....</div>
      </div>

      <SubjectCard
        :base_id="subject.base_id"
        :subject_id="subject.subject_id"
        :slug="subject.slug"
        :name="subject.name"
        :description="subject.description"
        :class_subject_count="subject.class_subject_count"
        :can_delete="subject.can_delete"
        v-for="(subject, index) in subject_list"
        :key="index"
        @removeSubject="deleteSubjectFromList($event)"
        @openSubjectDetail="toggleSubjectDetailModal($event)"
        v-else
      ></SubjectCard>
      <!-- SUBJECT CARD COMPONENTS -->

      <!--  MODAL COMPONENTS -->
      <AddSubjectModal
        v-if="subject_modal"
        @closeTriggered="toggleSubjectModal"
        @showAlertCard="popUpAlert($event)"
      ></AddSubjectModal>

      <SubjectDetailsModal
        v-if="subject_detail_modal"
        @closeTriggered="toggleSubjectDetailModal"
      ></SubjectDetailsModal>

      <ResponseDialog
        v-if="response_dialog"
        :alert_msg="alert_card_msg"
        :alert_type="alert_card_type"
        @closeAlert="toggleResponseDialog"
      ></ResponseDialog>
      <!--  MODAL COMPONENTS -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SubjectPreference",

  components: {
    SubjectCard: () =>
      import(
        /* webpackChunkName: "SubjectCard" */ "@/components/globalComps/SettingsComps/PreferenceComps/SubjectCard"
      ),
    AddSubjectModal: () =>
      import(
        /* webpackChunkName: "SubjectCard" */ "@/components/modalComps/settingsModals/AddSubjectModal"
      ),
    SubjectDetailsModal: () =>
      import(
        /* webpackChunkName: "SubjectCard" */ "@/components/modalComps/settingsModals/SubjectDetailsModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  data() {
    return {
      subject_modal: false,
      subject_detail_modal: false,
      subject_list: [],
      subject_detail_id: null,

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  created() {
    this.$bus.$on("event-bus-reload-subject-list", () => {
      this.fetchSubjectList();
    });
  },

  mounted() {
    this.fetchSubjectList();
    localStorage.removeItem("subject_detail_id");
  },

  methods: {
    ...mapActions(["getSubjectList", "getBoardingStatus", "removeSubject"]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert($event) {
      this.alert_card_msg = $event.msg;
      this.alert_card_type = $event.type;
      this.toggleResponseDialog();
    },

    fetchSubjectList() {
      this.getSubjectList()
        .then((response) => {
          console.log(response);

          if (response.code === 200) {
            // CHECK IF SUBJECT LIST IS POPULATED
            if (response.data.length === 0) {
              this.getBoardingStatus();
              this.fetchSubjectList();
            }

            this.subject_list = response.data.map((subject) => {
              return {
                base_id: Number(subject.id),
                subject_id: Number(subject.subject_id),
                slug: subject.slug,
                name: subject.name,
                description: subject.description,
                can_delete: Number(subject.can_delete),
                class_subject_count: Number(subject.class_subject_count),
              };
            });
          }
        })
        .catch((err) => console.log(err));
    },

    deleteSubjectFromList($event) {
      this.removeSubject($event.id)
        .then((response) => {
          if (response.code === 200) {
            this.alert_card_type = "success";
            this.alert_card_msg = `${$event.name} was removed from subject list`;
            this.toggleResponseDialog();
            this.fetchSubjectList();
          } else {
            this.alert_card_type = "error";
            this.alert_card_msg = `An error occured while removing ${$event.name} from subject list`;
            this.toggleResponseDialog();
            this.fetchSubjectList();
          }
        })
        .catch((err) => console.log(err));
    },

    toggleSubjectModal() {
      this.subject_modal = !this.subject_modal;
      this.subject_list = [];
      this.fetchSubjectList();
    },

    toggleSubjectDetailModal($event) {
      this.subject_detail_modal = !this.subject_detail_modal;

      if (localStorage.getItem("subject_detail_id") === null) {
        localStorage.setItem("subject_detail_id", $event.subject_id);
      } else {
        localStorage.removeItem("subject_detail_id");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preference-title {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}
</style>
